module.exports = __webpack_public_path__ + "img/6类感染.90fb6ad0.webp";